import { render, staticRenderFns } from "./StorkProductList.vue?vue&type=template&id=006b2eac&scoped=true&"
import script from "./StorkProductList.vue?vue&type=script&lang=js&"
export * from "./StorkProductList.vue?vue&type=script&lang=js&"
import style0 from "./StorkProductList.vue?vue&type=style&index=0&id=006b2eac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006b2eac",
  null
  
)

component.options.__file = "StorkProductList.vue"
export default component.exports